module.exports = __webpack_public_path__ + "f4c4996a7ff7b0bfdddc78c76148a440.svg";